import { DAY, MONTH, YEAR } from 'components/common/bryntumScheduler/constants';

const TIMELINE_ADDED_PADDING_PERCENT: number = 0.25; // between 0 and 1
export const parseDate = (value: Date | string, path: string = '') => {
    if (!value) return null;
    if (value instanceof Date) return value;
    const d = new Date(value);
    if (Number.isNaN(+d)) {
        throw new Error(`Invalid date at ${path}: ${String(value)}`);
    }
    return d;
};

export const dayDiff = (a: number, b: number) => {
    return Math.round((b - a) / DAY);
};

export const chooseViewPreset = (startDate: number | undefined, endDate: number | undefined) => {
    if (startDate == null || endDate == null) return undefined;
    const spanYears = (endDate - startDate) / YEAR;

    // If total timespan( response timespan + padding) of the scheduler is 3 years or more, then the timespan will show quarters for each year
    if (spanYears >= 3) {
        return 'year';
    }

    // total timespan is less than 3 years the view will be monthly.
    return {
        base: 'monthAndYear',
        headers: [
            { unit: 'year', dateFormat: 'YYYY' },
            { unit: 'month', dateFormat: 'MMM' },
        ],
    };
};

export const getTimelineSpanWithPadding = (
    startDate: number | undefined,
    endDate: number | undefined,
): {
    paddedStart: number | undefined;
    paddedEnd: number | undefined;
} => {
    if (startDate == null || endDate == null) {
        return {
            paddedStart: undefined,
            paddedEnd: undefined,
        };
    }
    const timeSpan = endDate - startDate;
    // could be 0 if we have only 1 milestone or several milestones with the same date
    if (timeSpan === 0) {
        return {
            paddedStart: startDate - MONTH,
            paddedEnd: endDate + MONTH,
        };
    }
    const addedPadding = timeSpan * TIMELINE_ADDED_PADDING_PERCENT;
    return {
        paddedStart: startDate - addedPadding,
        paddedEnd: endDate + addedPadding,
    };
};
